import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CollectionsIcon from '@mui/icons-material/Collections';
import HistoryIcon from '@mui/icons-material/History';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useRace } from '@/core/contexts/RaceContext';
import { useDocumentTitle } from '@/core/hooks/useDocumentTitle';
import { useFavicon } from '@/core/hooks/useFavicon';
import { DrawerMenu, type MenuItem } from '../DrawerMenu';
import { Footer } from '../Footer';
import { Header } from '../Header';

/** ユーザー向け画面のナビゲーション */
const userMenuItems: MenuItem[] = [
  { label: 'ギャラリー', path: '/gallery', icon: <CollectionsIcon /> },
  { label: '受け取り履歴', path: '/history', icon: <HistoryIcon /> },
  { label: 'ウォレット情報', path: '/wallet', icon: <AccountBalanceWalletIcon /> },
];

/**
 * 大会ユーザー向け画面のレイアウト
 * ヘッダー（大会ロゴ + タイトル + ハンバーガー）+ コンテンツ + フッター
 */
export function RaceUserLayout() {
  const { race } = useRace();
  const [drawerOpen, setDrawerOpen] = useState(false);

  // 大会ごとのタイトルに切り替え
  useDocumentTitle(`${race.name} NFT完走証 | RunPort NFT`);

  // 大会ごとのファビコンに切り替え
  useFavicon(`/races/${race.alias}/favicon.ico`);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header
        titleImage={`/races/${race.alias}/title.png`}
        titleImageSm={`/races/${race.alias}/title_sm.png`}
        onMenuClick={() => setDrawerOpen(true)}
      />

      <Container component="main" maxWidth="sm" sx={{ flex: 1, py: 3 }}>
        <Outlet />
      </Container>

      <Footer />

      <DrawerMenu
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        menuItems={userMenuItems}
        raceAlias={race.alias}
      />
    </Box>
  );
}
